/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wild_Wise_Fish_ClapInputs */

const en_wild_wise_fish_clap = /** @type {(inputs: Wild_Wise_Fish_ClapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share segments`)
};

const de_wild_wise_fish_clap = /** @type {(inputs: Wild_Wise_Fish_ClapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmente freigeben`)
};

/**
* | output |
* | --- |
* | "Share segments" |
*
* @param {Wild_Wise_Fish_ClapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wild_wise_fish_clap = /** @type {((inputs?: Wild_Wise_Fish_ClapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wild_Wise_Fish_ClapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wild_wise_fish_clap(inputs)
	return de_wild_wise_fish_clap(inputs)
});